'use strict';
import React from 'react';
import { cn } from '@src/utils/ui.js';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Button, IconButton } from '@mui/material';

class PaginationComponent extends React.Component {
    renderPageButton(direction = 'prev') {
        const { totalRecords, pageSize, pageNumber } = this.props;

        if (!totalRecords || totalRecords <= pageSize) return null;

        const isPrev = direction === 'prev';
        const Icon = isPrev ? ArrowBackIosIcon : ArrowForwardIosIcon;
        const ariaLabel = isPrev ? 'Previous Page' : 'Next Page';
        const targetPage = isPrev ? pageNumber - 1 : pageNumber + 1;

        return (
            <IconButton
                aria-label={ariaLabel}
                className='tw-bg-white tw-rounded-none tw-h-[45px] tw-w-[45px] tw-flex tw-items-center tw-justify-center'
                onClick={() => this.goToPage(targetPage)}
            >
                <Icon
                    className='tw-text-primary-500 tw-text-[40px] tw-block tw-leading-none tw-ml-[2px]'
                    fontSize='inherit'
                />
            </IconButton>
        );
    }

    showPages() {
        if (typeof this.props.totalRecords === 'undefined' || this.props.totalRecords <= 0) {
            return null;
        }
        //use for pagination ellipsis
        let totalPages = Math.ceil(this.props.totalRecords / this.props.pageSize);
        var current = this.props.pageNumber,
            last = totalPages,
            delta = 4,
            left = current - delta,
            right = current + delta + 1,
            range = [],
            l;

        let pageList = [];
        range.push(1);
        for (let i = current - delta; i <= current + delta; i++) {
            if (i >= left && i < right && i < last && i > 1) {
                range.push(i);
            }
        }
        if (last != 1) range.push(last);
        for (let i of range) {
            if (l) {
                if (i - l === 2) {
                    pageList.push(l + 1);
                } else if (i - l !== 1 && range.length >= 6) {
                    pageList.push('...');
                }
            }
            pageList.push(i);
            l = i;
        }
        //end ellipsis

        return (
            <ul className='pages-ul tw-flex tw-items-center'>
                {pageList.map(i => {
                    const isActive = this.props.pageNumber === i;

                    return (
                        <li key={i} className=''>
                            <Button
                                variant={!isActive ? 'outlined' : 'contained'}
                                style={
                                    !isActive
                                        ? {
                                              border: '1px solid rgba(0, 0, 0, 0.2)' // 0.2px border-width implementation
                                          }
                                        : undefined
                                }
                                className={cn(
                                    'tw-min-w-[31px] tw-h-[45px] tw-gap-[10px] tw-p-[10px] tw-font-[400] tw-text-[16px] tw-leading-[30px] tw-tracking-[0]',
                                    'focus:tw-outline-none focus:tw-ring-0 focus:tw-shadow-none',
                                    !isActive &&
                                        ' tw-bg-white tw-text-[#8B8B8B] hover:tw-text-[#8B8B8B] focus:tw-text-[#8B8B8B] active:tw-text-[#8B8B8B]',
                                    isActive &&
                                        'tw-bg-primary-500 tw-text-white hover:tw-bg-primary-500 hover:tw-text-white focus:tw-text-white active:tw-text-white'
                                )}
                                onClick={e => {
                                    e.preventDefault();
                                    this.goToPage(i);
                                }}
                            >
                                {i}
                            </Button>
                        </li>
                    );
                })}
            </ul>
        );
    }

    goToPage(pageNo) {
        if (typeof this.props.goToPage === 'function') {
            let totalPages = Math.ceil(this.props.totalRecords / this.props.pageSize);
            if (pageNo != this.props.pageNumber && pageNo > 0 && pageNo <= totalPages) {
                const urlParams = new URLSearchParams(window.location.search);
                urlParams.set('page', pageNo);
                window.history.pushState({}, '', `${window.location.pathname}?${urlParams}`);

                this.props.goToPage(pageNo, this.props.filters);
            }
        }
    }

    render() {
        if (this.props.pagingState && this.props.pagingState === 'hide') {
            return '';
        }
        return (
            <div className='tw-flex tw-justify-center tw-max-w-[1440px] tw-h-[168px] tw-gap-[3px] tw-pt-[60px] tw-pb-[60px] tw-mx-auto'>
                {this.renderPageButton('prev')}
                {this.showPages()}
                {this.renderPageButton('next')}
            </div>
        );
    }
}

export default PaginationComponent;
